<template>
  <div>
    <!-- 订单列表 -->
    <div class="table-list bg-white mb15 border-radius-4" v-for="(order,i) in dataList" :key="i">
      <div class="ptb18 plr20 border-b">
        <p class="ft12">
          <span class="cmain mr30 ft14 fw700"><span class="iconfont iconicon-zhongjianbaise ft16 cmain mr8 fw400"></span>订单号：<span class="">{{ order.OwnerOrderNo || '--' }}</span></span>
        </p>
      </div>
      <!-- PT201807000152 -->
      <div class="table-cont">
        <a-row class="flex table-header plr10 flex-justify">
          <div class="table-header-item c888" style="width:10%;">物料号</div>
          <div class="table-header-item c888" style="width:11%;">物料名称</div>
          <div class="table-header-item c888" style="width:7%;">物料状态</div>
          <div class="table-header-item c888" style="width:9%;">批次号</div>
          <div class="table-header-item c888" style="width:7%;">数量</div>
          <div class="table-header-item c888" style="width:7%;">包装单位</div>
          <div class="table-header-item c888" style="width:9%;">基本数量</div>
          <div class="table-header-item c888" style="width:7%;">基本单位</div>
          <div v-if="activeMenu!=='2'" class="table-header-item c888" style="width:9%;">净重</div>
          <div class="table-header-item c888" style="width:9%;">毛重</div>
          <div v-if="showPONo" class="table-header-item c888" style="width:7%;">PO No</div>
          <div class="table-header-item c888" style="width:8%;">入库日期</div>
        </a-row>
        <a-row v-for="(dcrItem,ii) in order.DCR" :key="ii" class="flex table-con tc ptb10 plr10 flex-acenter flex-justify">
          <div class="table-con-item c333" style="width:10%;">{{ dcrItem.OwnerCargoCode || '  ' }}</div>
          <div class="table-con-item c333" style="width:11%;">{{ dcrItem.CargoNameCn || '  ' }}</div>
          <div class="table-con-item c333" style="width:7%;">{{ dcrItem.CargoStatusName || '  ' }}</div>
          <div class="table-con-item c333" style="width:9%;">{{ dcrItem.BatchNo || '  ' }}</div>
          <div class="table-con-item c333" style="width:7%;">{{ dcrItem.Qty || '  ' }}</div>
          <div v-if="activeMenu==='2'" class="table-con-item c333" style="width:7%;">{{ dcrItem.PackUnitName2Owner || '  ' }}</div>
          <div v-else class="table-con-item c333" style="width:7%;">{{ dcrItem.PerUnitCode || '  ' }}</div>
          <div class="table-con-item c333" style="width:9%;">{{ dcrItem.BaseQty || '  ' }}</div>
          <div class="table-con-item c333" style="width:7%;">{{ dcrItem.BaseUnitCode || '  ' }}</div>
          <div v-if="activeMenu!=='2'" class="table-con-item c333" style="width:9%;">{{ dcrItem.NetWeight || '  ' }}</div>
          <div class="table-con-item c333" style="width:9%;">{{ dcrItem.GrossWeight || '  ' }}</div>
          <div v-if="showPONo" class="table-con-item c333" style="width:7%;">{{ dcrItem.PONo || '  ' }}</div>
          <div v-if="activeMenu==='2'" class="table-con-item c333" style="width:8%;">{{ (dcrItem.InDate&&dcrItem.InDate.substr(0,10)) || '  ' }}</div>
          <div v-else class="table-con-item c333" style="width:8%;">{{ dcrItem.FinishDT || '  ' }}</div>
        </a-row>
        <a-row class="flex table-con tc ptb10 plr10 flex-acenter flex-justify border-t">
          <div class="table-con-item c333 fw700" style="width:10%;">合计</div>
          <div class="table-con-item c333" style="width:11%;"></div>
          <div class="table-con-item c333" style="width:7%;"></div>
          <div class="table-con-item c333" style="width:9%;"></div>
          <div class="table-con-item c333 fw700" style="width:7%;">{{ (order.totalQty || 0).toFixed(2) }}</div>
          <div class="table-con-item c333" style="width:7%;"></div>
          <div class="table-con-item c333 fw700" style="width:9%;">{{ (order.totalBaseQty || 0).toFixed(2) }}</div>
          <div class="table-con-item c333" style="width:7%;"></div>
          <div v-if="activeMenu!=='2'" class="table-con-item c333 fw700" style="width:9%;">{{ (order.totalNetWeight || 0).toFixed(2) }}</div>
          <div class="table-con-item c333 fw700" style="width:9%;">{{ (order.totalGrossWeight || 0).toFixed(2) }}</div>
          <div v-if="showPONo" class="table-con-item c333" style="width:7%;"></div>
          <div class="table-con-item c333" style="width:8%;"></div>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import { dateToString } from '@/utils/date-formatter'
import { Ellipsis } from '@/components'
export default {
  name: 'TableList',
  components: { Ellipsis },
  props: {
    dataList: {
      type: Array,
      default: () => []
    },
    showPONo: {
      type: Boolean,
      default: false
    },
    activeMenu: {
      type: String,
      default: '1'
    }
  },
  data () {
    return {
      List: []
    }
  },
  mounted () {
    this.List.length = this.dataList.length
  },
  methods: {
    dateToString,
    collapseChange (index) {
      this.List[index] = !this.List[index]
      this.List = JSON.parse(JSON.stringify(this.List))
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../../styles/var.less';
.table-cont {
  .table-header {
    background-color: @light-blue-bg-table;
    height: 40px;
    line-height: 40px;
    .table-header-item {
      text-align: center;
      padding: 0 5px;
    }
  }
  .table-con {
    .table-con-item {
      padding: 0 5px;
      text-align: center;
      word-wrap:break-word;
      line-height: 1.2;
      min-height: 20px;
    }
  }
}
.nowarp {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
